export default [
  {
    name: "Alfa Romeo",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "83"
  },
  {
    name: "Aston Martin",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "74"
  },
  {
    name: "Audi",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "161"
  },
  {
    name: "BMW",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "85"
  },
  {
    name: "Chevrolet",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "84"
  },
  {
    name: "Citroen",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "91"
  },
  {
    name: "Dacia",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "18"
  },
  {
    name: "Daihatsu",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "104"
  },
  {
    name: "Ferrari",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "13"
  },
  {
    name: "Fiat",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "8"
  },
  {
    name: "Ford",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "39"
  },
  {
    name: "Honda",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "147"
  },
  {
    name: "Hyundai",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "122"
  },
  {
    name: "Jaguar",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "110"
  },
  {
    name: "Jeep",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "144"
  },
  {
    name: "Kia",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "746"
  },
  {
    name: "Lancia",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "34"
  },
  {
    name: "Land rover",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "140"
  },
  {
    name: "Lexus",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "1962"
  },
  {
    name: "Mahindra",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "657"
  },
  {
    name: "Maserati",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "117"
  },
  {
    name: "Mazda",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "145"
  },
  {
    name: "Mercedes",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "33"
  },
  {
    name: "Mini",
    type: "carbeat_protection_hv",
    risk: "high",
    description: "Carbeat Protection HV",
    codice: "2222"
  },
  {
    name: "Mitsubishi",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "148"
  },
  {
    name: "Nissan",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "149"
  },
  {
    name: "Opel",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "20"
  },
  {
    name: "Peugeot",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "151"
  },
  {
    name: "Porshe",
    risk: "high",
    type: "carbeat_protection_hv",
    description: "Carbeat Protection HV",
    codice: "27"
  },
  {
    name: "Renault",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "62"
  },
  {
    name: "Seat",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "53"
  },
  {
    name: "Skoda",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "94"
  },
  {
    name: "Smart",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "2259"
  },
  {
    name: "Ssangyong",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "979"
  },
  {
    name: "Subaru",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "155"
  },
  {
    name: "Suzuki",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "156"
  },
  {
    name: "Toyota",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "103"
  },
  {
    name: "Volkswagen",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "101"
  },
  {
    name: "Volvo",
    type: "carbeat_protection_lv",
    risk: "low",
    description: "Carbeat Protection LV",
    codice: "98"
  }
];



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/data/riskPerMaker.js